export default "__VITE_ASSET__B$7mK77p__"